let state = {
  // 查询参数
  queryParams: {},
  selectArray: []
}

const mutations = {
  setPickerQueryParams(state, data) {
    state.queryParams = data
  },
  setPickerSelectArray(state, arr) {
    state.selectArray = arr
  }
}

const actions = {}

const getters = {}

export default {
  // namespaced:true,
  state,
  actions,
  mutations,
  getters
}
